import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function GerenciadorSitePrivilegios({ user, permissions, setPermissions }) {
  return (
    <>

      <Header header={'Gerenciador do site'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'GestãoBanner'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão do Banner'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'GestãoNoticias'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Noticias'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'GestãoDocumentos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Documentos'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'GestãoInformaçõesSite'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Informações do Site'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'GestãoArgitosCiêntifico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Argitos Ciêntifico'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
